<div class="container-all" [ngClass]="currentRout.replace('/', '')">
  <app-side-bar [currentRout]="currentRout" *ngIf="initialized"></app-side-bar>
  <div>
    <app-header [currentRout]="currentRout" *ngIf="initialized"></app-header>
    <div [ngClass]="{'initialized-sect': initialized}">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
